import { render, staticRenderFns } from "./HeartyChooseTypePopup.vue?vue&type=template&id=628f5a18&scoped=true"
import script from "./HeartyChooseTypePopup.vue?vue&type=script&lang=js"
export * from "./HeartyChooseTypePopup.vue?vue&type=script&lang=js"
import style0 from "./HeartyChooseTypePopup.vue?vue&type=style&index=0&id=628f5a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f5a18",
  null
  
)

export default component.exports